import React from 'react';
import RecommendedAccessories from '@hpstellar/pdp/RecommendedAccessories';

import withPageComponents from '../../../page/components/with-page-components';
import { withAddToCart } from '../../../product/components/purchase-button-container';
import { PriceContainer } from '../../../product/components/product-price/with-product-price';
import { getProductClickMetrics } from '../../../metrics/metrics-helpers';

import './cross-sell.less'

const PDP_XSELL_LIST_EVENT = 'pdp-accessories';

const trackPdpCrossSellMetrics = (product, position, trackCustomMetric) => {
    try {
        let productClickMetrics = getProductClickMetrics({ product, position, list: PDP_XSELL_LIST_EVENT });
        trackCustomMetric(
            'productClick',
            productClickMetrics
        )
    } catch (e) { }
}

const mapAccessories = (products, prices = {}, addToCart, trackCustomMetric, baseProductSku) => {
    return products.reduce((xsell, product, idx) => {
        const { name: title, images, rating, numReviews, sku, linkUrl, ksps } = product;
        const { regularPrice, salePrice, ctaText, isOOS } = prices[sku] || {};
        if (!isOOS && salePrice !== '') {
            xsell.push({
                title,
                productUrl: linkUrl,
                images: images.map(i => ({ url: i.lrg })),
                bulletPoints: ksps,
                ratings: {
                    score: rating,
                    reviewsCount: numReviews
                },
                price: {
                    regularPrice,
                    salePrice
                },
                translations: {
                    add_to_basket: ctaText,
                    learn_more: <p onClick={() => trackPdpCrossSellMetrics(product, idx + 1, trackCustomMetric)}>Learn more</p>
                },
                onAdd: () => {
                    addToCart(product, 1, false, undefined, undefined, baseProductSku, PDP_XSELL_LIST_EVENT, { list: PDP_XSELL_LIST_EVENT });
                }
            })
        }
        return xsell
    }, []);
};

const pdpCrossSell = ({ product, pdpCrossSell, addToCart, trackCustomMetric }) => {
    const { sku } = product || {};
    const { relatedProducts } = pdpCrossSell || {}
    const onMoreLinkClick = () => {
        trackCustomMetric('linkClick', {
            event: 'e_linkClick',
            linkPlacement: 'accessories',
            linkId: 'more'
        });
    }
    const moreLink = {
        title: <div onClick={onMoreLinkClick}>More Accessories</div>,
        url: `${process.env.BASENAME}/plp/accessories`
    }

    if (relatedProducts && relatedProducts.length > 0) {
        return (
            <PriceContainer products={relatedProducts}>
                {
                    ({ prices }) => {
                        const accessories = mapAccessories(relatedProducts, prices, addToCart, trackCustomMetric, sku);
                        return accessories.length > 0 ? <RecommendedAccessories
                            className='cross-sell-carousel'
                            title={'RECOMMENDED ACCESSORIES'}
                            desktopTitle={'RECOMMENDED ACCESSORIES'}
                            moreLink={moreLink}
                            accessories={mapAccessories(relatedProducts, prices, addToCart, trackCustomMetric, sku)}
                        /> : null;
                    }
                }
            </PriceContainer>);
    }
    return null;
}

export default withPageComponents(withAddToCart(pdpCrossSell), { components: ['pdpCrossSell', 'product'] })
